module.exports = __webpack_public_path__ + "static/media/where-2.2b4be8a1.png";